module.exports = __webpack_public_path__ + "static/media/comment-alt-plus.dcc42771.svg";